// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2KQGC","name":"Header_name__2ClSc","birthday":"Header_birthday__MPsrO","skeleton":"Header_skeleton__73PR4"};